import type { ReactNode } from 'react';
import { Link } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';

export function LegalPage({
  title,
  lead,
  children,
}: {
  title: string;
  lead?: string;
  children: ReactNode;
}) {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="container-page max-w-3xl">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-sm text-ink-2 transition-colors hover:text-ink"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to home
        </Link>

        <h1 className="mt-8 text-4xl font-semibold tracking-tight text-ink md:text-5xl">{title}</h1>
        {lead ? <p className="mt-4 text-lg text-ink-2">{lead}</p> : null}

        <div className="mt-8 space-y-5 text-base leading-relaxed text-ink-2">{children}</div>
      </div>
    </section>
  );
}
